import { CSSProperties } from 'react';
import { CSS, Transform } from '@dnd-kit/utilities';

/**
 * Lo stile che dnd-kit produce durante il trascinamento.
 *
 * `useSortable` calcola `transform` e `transition` ma non li applica da sé: se
 * non glieli si passa, le righe restano ferme mentre si trascina e saltano
 * nella posizione nuova solo al rilascio. Con questi due valori la riga segue
 * il cursore e le altre si scansano scorrendo.
 *
 * È uno stile inline perché è un valore di runtime — cambia a ogni frame del
 * gesto — e nessuna classe può rappresentarlo: stessa eccezione della barra
 * colorata delle categorie.
 *
 * `Translate` e non `Transform`: la variante completa include anche la scala,
 * e su una riga a larghezza piena la scala deforma il testo mentre la si
 * trascina.
 */
export const sortableStyle = (
  transform: Transform | null,
  transition: string | undefined,
  isDragging: boolean,
): CSSProperties => ({
  transform: CSS.Translate.toString(transform),
  transition,
  /* La riga in mano passa SOPRA le altre: senza, scorrendo sopra il gruppo
     successivo ci finisce sotto e sembra sparita. */
  zIndex: isDragging ? 2 : undefined,
  position: isDragging ? 'relative' : undefined,
});
